import { LookBackMeasurement } from '../LookBackPeriod';

const MINUTES_IN_AN_HOUR = 60;
const MINUTES_IN_A_DAY = MINUTES_IN_AN_HOUR * 24;

export const convertToMeasurement = (valueInMinutes: number): { value: number; measurement: LookBackMeasurement } => {
  const valueConvertedToDays = valueInMinutes / MINUTES_IN_A_DAY;
  const valueConvertedToHours = valueInMinutes / MINUTES_IN_AN_HOUR;

  if (!valueInMinutes) {
    return { value: 24, measurement: 'hours' };
  }

  // If the minutes is equal to either 24 hours or 1 day then we always
  // want to display it in hours.
  const isTwentyFourHours = valueConvertedToHours === 24;
  if (isTwentyFourHours) {
    return { value: valueConvertedToHours, measurement: 'hours' };
  }

  const isDays = Number.isInteger(valueConvertedToDays) && valueConvertedToHours > 23;
  if (isDays) {
    return { value: valueConvertedToDays, measurement: 'days' };
  }

  const isHours = Number.isInteger(valueConvertedToHours);
  if (isHours) {
    return { value: valueConvertedToHours, measurement: 'hours' };
  }

  throw new Error('Unable to convert value to measurement');
};
